import angular from 'angular';
import floatingActionButtonsComponent from './floatingActionButtons.component';
import floatingActionButtonsService from './floatingActionButtons.service';

let floatingActionButtonsModule = angular.module('floatingActionButtons', [
])

  .component('floatingActionButtons', floatingActionButtonsComponent)

  .service('floatingActionButtonsService', floatingActionButtonsService)

  .name;

export default floatingActionButtonsModule;



// WEBPACK FOOTER //
// ./client/app/components/floatingActionButtons/floatingActionButtons.js